<template>
  <div>
    <label class="sr-only" for="inlineFormInputGroup">{{ label }}</label>

    <form class="input-group mb-2" @submit.prevent="setSearch">
      <div class="input-group-prepend input-group-text">
        <i :class="searchIcon" />
      </div>

      <input id="inlineFormInputGroup" v-model="searchValue" type="text" class="form-control" :placeholder="label" />

      <w-button type="submit" text="Wyszukaj" class="btn-primary input-group-append" />

      <w-button type="button" text="Wyczyść" icon="fas fa-times" class="btn-danger" @click="clearSearch" />
    </form>
  </div>
</template>

<script>
// @vuese
// Pole do wyszukiwania
// @group Helpers
export default {
  name: 'SearchBox',
  props: {
    // Label pola wyszukiwania
    label: {
      type: String,
      default: 'Wyszukaj',
      required: false
    },
    // Ikona wyszukiwania
    searchIcon: {
      type: String,
      default: 'fal fa-fw fa-search',
      required: false
    }
  },
  data() {
    return {
      searchValue: this.$route.query.search || ''
    };
  },
  watch: {
    $route(newRoute) {
      this.searchValue = newRoute.query?.search || '';
    }
  },
  methods: {
    // @vuese
    // Czyści wyszukanie
    clearSearch() {
      this.searchValue = '';
      this.setSearch();
    },

    // @vuese
    // Ustawia wyszukiwaną frazę
    setSearch() {
      this.reload({ ...this.$route.query, start: 0, search: this.searchValue || undefined });
    },
    // @vuese
    // Przeładowuje stronę
    reload(query) {
      const nextRoute = { name: this.$route.name, params: this.$route.params, query };
      this.$router.replace(nextRoute);
    }
  }
};
</script>

<style scoped>
.btn-primary.input-group-append {
  font-weight: 700;
  text-transform: uppercase;
}
.input-group-text {
  border-radius: 0;
}
</style>
